import { render, staticRenderFns } from "./ButtonSignup.vue?vue&type=template&id=a71b1d10&"
import script from "./ButtonSignup.vue?vue&type=script&lang=js&"
export * from "./ButtonSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports